import axios from '@/util/request';




export function reviewStreamPage(parameter) {
  return axios({
    url: '/ims/reviewStream/page',
    method: 'get',
    params: parameter,
  })
}
export function reviewStream(id) {
  return axios({
    url: '/ims/reviewStream/' + id,
    method: 'get',
  })
}
export function updateReviewStream(parameter) {
  //获取异常仪器列表
  return axios({
    url: '/ims/reviewStream/review',
    method: 'put',
    data: parameter
  })
}



export function getInstrumentPageList(parameter) {
  //获取仪器列表
  return axios({
    url: '/ims/instrument/page',
    method: 'post',
    data: parameter
  })
}

export function getInstrumentList(parameter) {
  //获取仪器列表
  return axios({
    url: '/ims/instrument/page/maintained',
    method: 'post',
    data: parameter
  })
}


export function getBrokeInsList(parameter) {
  //获取异常仪器列表
  return axios({
    url: '/ims/instrument/page/broke',
    method: 'post',
    data: parameter
  })
}










// WEBPACK FOOTER //
// ./src/api/approve.js